{
  "$id": "wealthlane://forms/role-mapping",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../role-mapping.domain.json",
  "properties": {
    "destinationRoleId": {
      "$ref": "module://role-mapping#properties/destinationRoleId",
      "required": true
    },
    "selectedRoleMappingItems": {
      "$ref": "module://role-mapping#properties/selectedRoleMappingItems",
      "default": []
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_ROLE_MAPPING",
      "refreshEntities": ["RoleMapping"],
      "invalidateQueries": ["getAllowedRoleMappings"]
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "submit": {
          "successMessage": "Allowed Role Mapping Added."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "submit": {
          "successMessage": "Allowed Role Mapping Edited."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "viewPresentation": "disabled-inputs"
    }
  }
}
